import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { ToastService } from 'shared';
import { ApiInvestigadorService } from 'src/app/core/services/api-investigador.service';
import { removeSpaces } from 'src/app/core/utils/not-empty-validation';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-encuesta-api',
  templateUrl: './modal-encuesta-api.component.html',
  styleUrls: ['./modal-encuesta-api.component.scss']
})
export class ModalEncuestaApiComponent implements OnInit {

  form: FormGroup;
  environment = environment;
  siteKey = environment.keys.GOOGLE_RECAPTCHA;
  sended = false;
  showError = null;
  loading = false;

  constructor(
    private toast: ToastService,
    private store: Store,
    public dialogRef: MatDialogRef<ModalEncuestaApiComponent>,
    private formBuilder: FormBuilder,
    private apiInvestigadorService: ApiInvestigadorService,
    @Inject(MAT_DIALOG_DATA) public data: {  }
  ) { }

  ngOnInit(): void {
    this.buildForm()
  }

  buildForm = () => {
    this.form = this.formBuilder.group({
      recaptcha: ['', Validators.required],
      usoFacil: [null, Validators.required],
      contenidoInformacion: [null, Validators.required],
      informacion: [null, [Validators.required, removeSpaces, Validators.maxLength(500)]],
      objetivo: [null, [Validators.required, removeSpaces, Validators.maxLength(500)]],
    });
  }

  ngOnDestroy() { }

  handleClose = () => {
    this.dialogRef.close();
  }

  handleAceptar = () => {
    this.dialogRef.close();
  }

  handleSuccess = (value) => {
    this.form.get('recaptcha').setValue(value)
  }

  handleEnviar (){
    if(this.loading)
      return false;
      
    if(this.form.valid){
      this.loading = true;
      this.apiInvestigadorService.postRegistrarEncuesta({
        recaptcha: this.form.value.recaptcha,
        usoFacil: this.form.value.usoFacil,
        contenidoInformacion: this.form.value.contenidoInformacion,
        informacion: this.form.value.informacion,
        objetivo: this.form.value.objetivo,
        version: environment.versionEncuesta
      }).subscribe((value: any) => {
        this.loading = false;
        if(value.success)
          this.sended = true
        else
          this.showError = true
      });
    } else {
      console.log(this.form.value)
      this.toast.error('Se debe registrar todos los campos obligatorios.');
      this.form.markAllAsTouched();
    }
  }
}
